// extracted by mini-css-extract-plugin
export default {"root":"mimic___style_root__E+oLP","sm":"mimic___style_sm__4HG+y","md":"mimic___style_md__2zkL0"};